import loadable from '@loadable/component'

export const asyncLoad = loader => loadable(loader)
